import Datatable from '@laraveldaily/vue2-datatable'
// import {abilitiesPlugin} from '@casl/vue'
// import ability from "./core/plugins/ability";
import priceInput from "@/view/pages/pickers/priceInput";
import EventHub from "./core/plugins/EventHubPlugin/EventHub";
import acl from './core/plugins/acl'
import BackButton from './view/pages/plugins/BackButton'
import VueTypedJs from 'vue-typed-js'
import ResponseMessageFunctions from "./Utilities/ResponseMessageFunctions";

const GlobalComponents = {
    install(Vue) {
        Vue.use(Datatable)
        Vue.use(VueTypedJs)
        // Vue.use(abilitiesPlugin, ability)
        Vue.use(EventHub)
        Vue.component('back-button', BackButton)
        Vue.component('price-input', priceInput)
        Vue.use(acl)
        Vue.use(ResponseMessageFunctions)
    }
}

export default GlobalComponents
